import { AttendanceStateDto } from '../../../../api-service/clients';
import { ColorPalette } from '../../../../components/config';
import { getAttendanceStateColor } from '../../attendance-state-colors';

// The action-bar header and the citizen rows must offer the same buttons in the same order.
export const selectableAttendanceStates = [AttendanceStateDto.OnTime, AttendanceStateDto.NotOnTime, AttendanceStateDto.NotShown, AttendanceStateDto.AbsenceWithReason];

export function getButtonColor(attendanceState: AttendanceStateDto, selectedAttendanceState?: AttendanceStateDto) {
  return attendanceState === selectedAttendanceState ? getAttendanceStateColor(attendanceState) : 'inherit';
}

export function getStatisticsStateColor(selectedAttendanceState?: AttendanceStateDto) {
  switch (selectedAttendanceState) {
    case AttendanceStateDto.OnTime:
      return ColorPalette.SummaryGreenLight;
    case AttendanceStateDto.NotOnTime:
      return ColorPalette.SummaryOrangeLight;
    case AttendanceStateDto.NotShown:
      return ColorPalette.CrimsonLight;
    case AttendanceStateDto.AbsenceWithReason:
      return ColorPalette.SummaryGreenLight;
    case AttendanceStateDto.NotRelevant:
      return ColorPalette.CityNightSkies;
    default:
      return 'inherit';
  }
}

export function getAttendanceStateTextColor(selectedAttendanceState?: AttendanceStateDto) {
  switch (selectedAttendanceState) {
    case AttendanceStateDto.OnTime:
      return ColorPalette.WHITE;
    case AttendanceStateDto.NotOnTime:
      return ColorPalette.BLACK;
    case AttendanceStateDto.NotShown:
      return ColorPalette.WHITE;
    case AttendanceStateDto.AbsenceWithReason:
      return ColorPalette.WHITE;
    case AttendanceStateDto.NotRelevant:
      return ColorPalette.WHITE;
    default:
      return 'inherit';
  }
}
